export enum FundQueryMethod {
  Foundation = 'foundation',
  Fund = 'fund',
  Manual = 'manual',
}
